export const INDEX = 'REPLY_INDEX'
export const SEARCH = 'REPLY_SEARCH'
export const THREAD_ID = 'REPLY_THREAD_ID'
export const REPLIES = 'REPLY_REPLIES'
export const NEW_POST = 'REPLY_NEW_POST'
export const ON_CHANGE = 'REPLY_ON_CHANGE'
export const LOADING = 'COMMENTS_LOADING'

